import React from 'react'
import Helmet from 'react-helmet'

import './Shop.css'
import ProductItem from './ProductItem.js'

const sortByDate = (a, b) => (new Date(a.date) < new Date(b.date) ? 1 : -1)

const Shop = ({ galleryItems }) => {
  const renderProducts = () =>
    galleryItems
      .sort(sortByDate)
      .map(product => (
        <ProductItem
          key={product.name}
          title={product.title}
          images={product.images.map(item => item.image)}
          slug={product.name}
          url={product.buyUrl}
          price={product.price}
          stock={product.stock}
          currencyCode={product.currency_code}
        />
      ))

  return (
    <div className="Shop">
      <div className="section">
        <div className="container flex ShopContainer">{renderProducts()}</div>
      </div>
      <Helmet title="Gallery" />
    </div>
  )
}

export default Shop



// WEBPACK FOOTER //
// ./src/Shop/Gallery.js